import React from 'react';
import { useRequests } from '../Requests/containers/RequestsDataStore';
import ReviewCopyRequestModalAnchor from '../ReviewCopy/ReviewCopyRequestModalAnchor';
import CancelRequest from '../UI/Actions/CancelRequest';
import EnableRequest from '../UI/Actions/EnableRequest';

type DrcActionRequestOptionProps = {
	title: any;
	children?: React.ReactNode;
	tooltipPlacement: string;
	doAllowOpenReviewCopyActionOnMount: boolean;
};

DrcActionRequestOption.defaultProps = {
	doAllowOpenReviewCopyActionOnMount: false,
};

export default function DrcActionRequestOption({
	title,
	children,
	tooltipPlacement,
	doAllowOpenReviewCopyActionOnMount,
}: DrcActionRequestOptionProps) {
	const { sku } = title;
	const requestsDataStore = useRequests();

	const { requests, isLoading } = requestsDataStore.state;

	if (isLoading) {
		return <React.Fragment />;
	}

	const render = () => {
		const thisRequest = requests.find(req => req.sku === sku);

		if (thisRequest) {
			const { status } = thisRequest;

			if (status === 30) {
				return (
					<EnableRequest
						id={thisRequest.id}
						submittedDate={thisRequest.submittedDate}
						digitalUpdatedDate={title.digitalUpdatedDate}
						sku={sku}
					/>
				);
			}

			return (
				<CancelRequest
					id={thisRequest.id}
					submittedDate={thisRequest.submittedDate}
					digitalUpdatedDate={title.digitalUpdatedDate}
					sku={sku}
				/>
			);
		}

		return (
			<ReviewCopyRequestModalAnchor
				title={title}
				tooltipPlacement={tooltipPlacement}
				digitalCreatedDate={title.digitalCreatedDate}
				digitalUpdatedDate={title.digitalUpdatedDate}
				doAllowOpenOnMount={doAllowOpenReviewCopyActionOnMount}
			/>
		);
	};

	if (!children) {
		return render();
	}

	return (
		<div style={{ display: 'flex' }}>
			{render()}
			{children}
		</div>
	);
}
